
import { DashboardController } from "../controllers/dashboard-controller";
import { CarriersController } from "../controllers/carriers-controller";
import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { SecurityService } from "../services/security-service";
import { computedFrom, autoinject, observable } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import * as moment from 'moment';
import { PushMessage, SignalrService } from "../services/signalr-service";
import { Subscription } from "aurelia-event-aggregator";

@singleton()
@autoinject()
export class Dashboard {

    private isReloadNeeded = false;
    initialized: boolean = false;

    constructor(
        private busyService: BusyService,
        private securityService: SecurityService,
        private api: WebApiService,
        private signalr: SignalrService) {
    }

    tabCountData = {};
    carrierRows = [];

    activate() {
        //this needs to be called first
        this.currentMillCode = "All";



        if (this.signalr) {
            //don't need to worry about unsubscribing because the dashboard is never unloaded.
            this.signalr.listen(PushMessage.CarrierStatusChanged, (message) => {
                // when carrier data changes, we need to reload the dashboard whenever it is re-activated.
                this.isReloadNeeded = true;
            });
        }
    }

    attached() {
        if (this.isReloadNeeded) {
            this.reload();
            this.isReloadNeeded = false;
        } else {
            // set active tab on load
            if (this.securityService.user.millCodes.length > 0 || this.securityService.hasRole('Executive')) {
                this.selectTab("divisionRosterMA");
            } else {
                this.selectTab("newCarriers");
            }
        }
    }

    activeTab: string = "";


    async loadTabData() {

        this.busyService.on();
        try {
            const params = {
                dashboardId: this.activeTab
            };
            if (this.currentMillCode && this.currentMillCode != "All")
                params["millId"] = this.currentMillCode;

            var result = await this.api.get("Carriers", "GetDashboardScreenData", params);
            var data = JSON.parse(result.response);
            this.carrierRows = data.tabData;
            this.tabCountData = data.tabCountData;

            this.initialized = true;
        } finally {
            this.busyService.off();
        }


    }

    reload() {
        this.carrierPromise = null;
        this.loadTabData();
    }

    @observable()
    currentMillCode: string;
    currentMillCodeChanged() {
        if (this.initialized)
            this.reload();
    }
    carriers: Array<any>;
    carrierPromise: any;


    selectTab(activeTab: string) {
        this.activeTab = activeTab;
        this.loadTabData();
    }

}